<script setup lang="ts">
   import { ref, onMounted, onUnmounted } from 'vue';
   import { useRoute } from '#imports';
   import 'mmenu-light/dist/mmenu-light.css';
   import { SiteRouteNames } from '~/types/types';
   import { useIpaNavigation } from '../composables/useIpaNavigation';

   const route = useRoute();
   const { visibleItems } = useIpaNavigation();

   const menuElementRef = ref(null);
   let drawerInstance: any = null;

   onMounted(async () => {
      if (!menuElementRef.value) {
         return;
      }

      // mmenu-light touches browser globals at import time, so load it on the client
      // only — this keeps the nav SSR-safe (it renders during prerender for SEO).
      const { default: MmenuLight } = await import('mmenu-light');
      const menu = new MmenuLight(menuElementRef.value, '(max-width: 1023px)');

      menu.navigation({});
      drawerInstance = menu.offcanvas({});
   });

   function openDrawer() {
      if (drawerInstance) {
         drawerInstance.open();
      }
   }

   defineExpose({
      openMenu: openDrawer,
   });

   watch(
      () => route.fullPath,
      () => {
         if (drawerInstance) {
            drawerInstance.close();
         }
      },
   );
</script>

<template>
   <nav ref="menuElementRef" class="mx-auto" id="ipa-main-menu">
      <ul class="flex">
         <template v-for="item in visibleItems" :key="item.label">
            <PublicNavListItem v-if="item.to" :to="item.to">
               {{ item.label }}
            </PublicNavListItem>
         </template>
         <PublicNavListItem :to="{ name: SiteRouteNames.platform }">
            Enter Platform
         </PublicNavListItem>
      </ul>
   </nav>
</template>

<style scoped></style>
